import * as React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { Box, Icon, Tabs, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import useGetProcessConfigurationStatus from 'modules/processes/hooks/useProcessSettiingsValidation'
import { Process } from 'modules/processes/hooks/useProcesses'

const Component = ({ process }: { process: Process }) => {
  const location = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { category } = useParams()
  const [currentTab, setCurrentTab] = React.useState(
    location.pathname.split('/').pop() ?? 'settings'
  )

  const tabs = [
    {
      index: 'overview',
      name: i18n.t('processes.process.tabs.tasks_overview'),
      href: navigation.processes.template.id.overview.fullPath({
        category: category as string,
        id: process.id,
      }),
    },
    {
      index: 'employees',
      name: i18n.t('processes.process.tabs.employees'),
      href: navigation.processes.template.id.employees.fullPath({
        category: category as string,
        id: process.id,
      }),
    },
    {
      index: 'settings',
      name: i18n.t('processes.process.tabs.settings'),
      href: navigation.processes.template.id.settings.fullPath({
        category: category as string,
        id: process.id,
      }),
    },
  ]

  const handleTabClick = (id: string) => {
    const tab = tabs.find((tab) => tab.index == id)
    if (tab) {
      setCurrentTab(id)
      return navigate(tab.href)
    }
    return null
  }

  const { processValidationData } = useGetProcessConfigurationStatus(process)

  const status = processValidationData?.validSettings
    ? null
    : processValidationData?.validationMessage

  return (
    <>
      <Tabs currentId={currentTab} onTabClicked={handleTabClick}>
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.index} label={tab.name} id={tab.index}>
            {''}
          </Tabs.Tab>
        ))}
      </Tabs>
      {status && (
        <Box paddingTop="s16">
          <Box
            flexDirection="row"
            background="champagne400"
            width="full"
            gap="s8"
            paddingLeft="s24"
            paddingRight="s24"
            paddingBottom="s16"
            paddingTop="s16"
            borderRadius={{ all: 'abs008' }}
          >
            <Icon.Medium icon="info-circle-line" color="grey800" />
            <Text.Normal color="grey1000">{status}</Text.Normal>
          </Box>
        </Box>
      )}
    </>
  )
}

export default Component
